/**
 * PraticaListItem — F-005 Phase 4 (IMPL-P4-004).
 *
 * Singola riga `<tr>` della tabella pratiche cliente. Mirror dello stile di
 * `OperatorQueueTable` per coerenza visuale tra dashboard cliente/operatore.
 *
 * NB: il progetto non espone uno shadcn `Table` primitives; usiamo
 * `<tr>` / `<td>` HTML con classi Tailwind, come OperatorQueueTable.
 */
import { Link } from 'react-router-dom';
import type { PraticaListItem as PraticaListItemType } from '../lib/cliente-pratiche-client';
import { StateBadge } from './StateBadge';

const DATE_FORMATTER = new Intl.DateTimeFormat('it-IT', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

function formatItalianDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return DATE_FORMATTER.format(d);
}

interface PraticaListItemProps {
  item: PraticaListItemType;
}

export function PraticaListItem({ item }: PraticaListItemProps) {
  const updatedAt = formatItalianDate(item.updatedAt);
  return (
    <tr className="hover:bg-muted/30">
      <td className="px-3 py-2 font-mono text-xs">
        <Link
          to={`/app/pratiche/${item.id}`}
          className="text-primary underline-offset-4 hover:underline"
        >
          {item.codicePratica}
        </Link>
      </td>
      <td className="px-3 py-2">
        <StateBadge stato={item.stato} />
      </td>
      <td className="px-3 py-2 text-sm text-muted-foreground">{updatedAt}</td>
      <td className="px-3 py-2 text-right">
        <Link
          to={`/app/pratiche/${item.id}`}
          className="text-sm text-primary underline-offset-4 hover:underline"
        >
          Dettaglio
        </Link>
      </td>
    </tr>
  );
}
